import React from 'react';
import { Grid2 as Grid } from '@mui/material';

interface ProjectDashboardExpandedItemWrapperProps {
  children: React.ReactNode;
  bottomContent?: React.ReactNode;
}

const ProjectDashboardExpandedItemWrapper: React.FC<ProjectDashboardExpandedItemWrapperProps> = ({
  children,
  bottomContent,
}) => {
  return (
    <>
      <Grid container spacing={2} alignItems="flex-start">
        <Grid size={{ xs: 12 }}>{children}</Grid>
      </Grid>
      {bottomContent && (
        <Grid container>
          <Grid size={{ xs: 12 }} sx={{ mt: 4 }}>
            {bottomContent}
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default ProjectDashboardExpandedItemWrapper;
